export class JobApplication {
    public referralCode: string = '';
    public companyCode: string = '';
    public jobPostingId: number = 0;
    public resumeGUID: string = '';
    public utmTrackerId!: number;
    public userId: number = 0;
    public resumeCode: string = '';
    public sourceChannel:string ='Talent Portal'
}
